import { render, staticRenderFns } from "./NewNumbers.vue?vue&type=template&id=6998c316"
import script from "./NewNumbers.vue?vue&type=script&lang=js"
export * from "./NewNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports